export default `

    precision highp float;
    precision highp int;
    uniform sampler2D texture;
    uniform vec2 maskPosition;
    uniform int isOut;

    varying vec2 vUv;
    varying vec3 vNormal;
    varying vec3 newPosition;
    varying vec2 displacementUv;

    void main() {

        vec3 normal = normalize(vNormal);
        vec4 textureColor = texture2D(texture, vUv);

        // vec3 light = normalize(vec3(0.5, 1.0, -0.3));
        // float shading = dot(normal, light) * 0.15;

        float mask = 1.0;
        textureColor.r = textureColor.r - (newPosition.z);
        textureColor.b = textureColor.b - (newPosition.z);
        textureColor.g = textureColor.g - (newPosition.z);

        if(isOut == 0) {
            mask = step(vUv.y, maskPosition.y);
        } else {
            mask = 1.0 - step(vUv.y, maskPosition.y);
        }

        gl_FragColor.rgb = textureColor.rgb;
        gl_FragColor.a = max(mask,-.1);

        gl_FragColor.rgb *= gl_FragColor.a;
    }
`
